import http from '~/http/index';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: '',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.post('v2/Trading/GetOrderBook', {
        ...getters.requestData,
        ...data,
      });
      const {
        bids,
        asks,
        bidsTotalPrice,
        bidsTotalAmount,
        asksTotalAmount,
        bidsCount,
        asksCount,
      } = response.data;
      commit('SET_DATA', {
        bids,
        asks,
        bidsTotalPrice,
        bidsTotalAmount,
        asksTotalAmount,
      });
      if (bidsCount || asksCount) {
        const maxCount = Math.max(bidsCount, asksCount);
        const pages = Math.ceil(maxCount / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async cancelOrder(__store, data) {
      const response = await http.put('Trading/CancelOrder', data);
      return response.data;
    },
  },

  namespaced: true,
});
